import React from 'react';
import Icon from '@ant-design/icons';
import './CustomIcons.scss';

const FacebookSVG = () => (
  <svg
    t="1589880784755"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="1048"
  >
    <path
      d="M589.572 80.31c-27.149 0-52.789 3.018-82.955 15.084-61.839 25.639-92.003 82.955-92.003 174.957v88.987h-85.969v147.808h85.969v426.833h174.957v-426.833h119.152l16.59-147.808h-135.744v-66.363c0-21.115 1.508-36.197 7.54-43.741 7.54-13.573 22.624-19.607 46.755-19.607h79.937v-147.808h-134.235z"
      fill=""
      p-id="1049"
    ></path>
  </svg>
);

const SoundCloudSVG = () => (
  <svg
    t="1589880821424"
    viewBox="0 0 1025 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="1170"
  >
    <path
      d="M891.96544 514.21184c-18.08384 0-35.34848 3.52256-51.05664 9.85088-10.50624-114.36032-110.2848-204.06272-231.99744-204.06272-29.77792 0-58.6752 5.632-84.31616 15.1552-9.95328 3.70688-12.57472 7.51616-12.57472 14.90944l0 402.71872c0 7.76192 6.2464 14.2336 14.1312 14.99136 0.32768 0.04096 363.54048 0.2048 365.89568 0.2048 72.9088 0 131.9936-56.81152 131.9936-126.89408s-59.12576-126.89408-132.03456-126.89408zM399.99488 768l32.01024 0 15.99488-224.21504-15.99488-223.78496-32.01024 0-15.99488 223.78496zM304.00512 768l-32.01024 0-15.99488-162.75456 15.99488-157.24544 32.01024 0 15.99488 160.01024zM143.99488 768l32.01024 0 15.99488-128-15.99488-128-32.01024 0-15.99488 128zM15.99488 704l32.01024 0 15.99488-64-15.99488-64-32.01024 0-15.99488 64z"
      p-id="1171"
    ></path>
  </svg>
);

const TwitterSVG = () => (
  <svg
    t="1589880843661"
    viewBox="0 0 1025 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="1292"
  >
    <path
      d="M1024.032 194.432c-37.664 16.704-78.176 28-120.672 33.088 43.36-26.016 76.672-67.168 92.384-116.224-40.608 24.064-85.568 41.568-133.408 50.976-38.336-40.832-92.928-66.336-153.344-66.336-116.032 0-210.08 94.048-210.08 210.08 0 16.48 1.856 32.512 5.44 47.872-174.592-8.768-329.408-92.416-433.024-219.52-18.08 31.04-28.448 67.104-28.448 105.632 0 72.896 37.088 137.184 93.472 174.88-34.432-1.088-66.816-10.528-95.168-26.272-0.032 0.864-0.032 1.76-0.032 2.656 0 101.792 72.416 186.688 168.512 205.984-17.632 4.8-36.192 7.36-55.36 7.36-13.536 0-26.688-1.312-39.52-3.776 26.72 83.456 104.32 144.192 196.256 145.888-71.904 56.352-162.496 89.92-260.928 89.92-16.96 0-33.664-0.992-50.112-2.944 92.96 59.616 203.392 94.4 322.048 94.4 386.432 0 597.728-320.128 597.728-597.76 0-9.12-0.192-18.176-0.608-27.168 41.056-29.632 76.672-66.624 104.832-108.736z"
      p-id="1293"
    ></path>
  </svg>
);

const BandCampSVG = () => (
  <svg
    t="1589880861076"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="1414"
  >
    <path
      d="M611.428571 673.142857l174.857143-322.285714H412.571429l-174.857143 322.285714h373.714285z m412.571429-161.142857q0 104-40.571429 198.857143t-109.142857 163.428571-163.428571 109.142857-198.857143 40.571429-198.857143-40.571429-163.428571-109.142857-109.142857-163.428571T0 512t40.571429-198.857143 109.142857-163.428571T313.142857 40.571429 512 0t198.857143 40.571429 163.428571 109.142857 109.142857 163.428571 40.571429 198.857143z"
      p-id="1415"
    ></path>
  </svg>
);

const InstagramSVG = () => (
  <svg
    t="1589880883202"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="1536"
  >
    <path
      d="M658.247863 512c0-80.566857-65.718857-146.285714-146.285714-146.285714s-146.285714 65.718857-146.285715 146.285714 65.718857 146.285714 146.285715 146.285714 146.285714-65.718857 146.285714-146.285714z m78.848 0c0 124.562286-100.571429 225.133714-225.133714 225.133714S286.828434 636.562286 286.828434 512 387.399863 286.866286 511.962149 286.866286s225.133714 100.571429 225.133714 225.133714z m61.732571-234.276571c0 29.147429-23.442286 52.553143-52.553143 52.553142S693.722149 306.834286 693.722149 277.723429s23.442286-52.553143 52.553142-52.553143 52.553143 23.442286 52.553143 52.553143zM511.962149 151.990857c-64 0-201.142857-5.156571-258.852572 17.700572-20.004571 8.009143-34.852571 17.700571-50.285714 33.133714s-25.161143 30.281143-33.133714 50.285714c-22.857143 57.709714-17.700571 194.852571-17.700572 258.852572s-5.156571 201.142857 17.700572 258.852571c8.009143 20.004571 17.700571 34.852571 33.133714 50.285714s30.281143 25.161143 50.285714 33.133715c57.709714 22.857143 194.852571 17.700571 258.852572 17.700571s201.142857 5.156571 258.852571-17.700571c20.004571-8.009143 34.852571-17.700571 50.285714-33.133715s25.161143-30.281143 33.133715-50.285714c22.857143-57.709714 17.700571-194.852571 17.700571-258.852571s5.156571-201.142857-17.700571-258.852572c-8.009143-20.004571-17.700571-34.852571-33.133715-50.285714s-30.281143-25.161143-50.285714-33.133714C713.105006 146.834286 575.962149 151.990857 511.962149 151.990857zM950.819291 512c0 60.562286 0.585143 120.576-2.852571 181.138286-3.437714 70.290286-19.419429 132.571429-70.838857 183.990857s-113.700571 67.437714-183.990857 70.838857c-60.562286 3.437714-120.576 2.852571-181.138286 2.852571s-120.576 0.585143-181.138286-2.852571c-70.290286-3.437714-132.571429-19.419429-183.990857-70.838857S79.431863 763.428571 76.03072 693.138286C72.593006 632.576 73.178149 572.562286 73.178149 512s-0.585143-120.576 2.852571-181.138286c3.437714-70.290286 19.419429-132.571429 70.838857-183.990857s113.700571-67.437714 183.990857-70.838857c60.562286-3.437714 120.576-2.852571 181.138286-2.852571s120.576-0.585143 181.138286 2.852571c70.290286 3.437714 132.571429 19.419429 183.990857 70.838857s67.437714 113.700571 70.838857 183.990857C951.404434 391.424 950.819291 451.437714 950.819291 512z"
      fill=""
      p-id="1537"
    ></path>
  </svg>
);

const SpotifySVG = () => (
  <svg
    t="1589880898803"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="1658"
  >
    <path
      d="M512 0C230.4 0 0 230.4 0 512s230.4 512 512 512 512-230.4 512-512S796.16 0 512 0z m235.562667 739.84c-10.24 15.317333-28.16 20.48-43.562667 10.24-120.32-74.24-271.36-89.642667-450.602667-48.682667-17.834667 5.205333-33.237333-7.637333-38.357333-22.997333-5.12-17.962667 7.68-33.28 23.04-38.4 194.56-43.562667 363.52-25.6 496.64 56.32 17.92 7.68 20.437333 28.117333 12.842667 43.52z m61.44-140.8c-12.842667 17.92-35.882667 25.6-53.845334 12.8-138.197333-84.48-348.117333-110.08-509.397333-58.88-20.437333 5.12-43.52-5.12-48.64-25.6-5.12-20.48 5.12-43.562667 25.6-48.682667C409.6 422.4 640 450.602667 798.72 547.84c15.402667 7.722667 23.04 33.28 10.282667 51.2z m5.12-143.36C650.24 358.4 376.32 348.16 220.16 396.842667c-25.6 7.637333-51.2-7.722667-58.88-30.762667-7.68-25.642667 7.68-51.2 30.72-58.922667 181.76-53.76 481.28-43.52 670.762667 69.162667 22.997333 12.8 30.677333 43.52 17.877333 66.56-12.757333 17.962667-43.52 25.557333-66.517333 12.8z"
      fill=""
      p-id="1659"
    ></path>
  </svg>
);

const YoutubeSVG = () => (
  <svg
    t="1589880911001"
    viewBox="0 0 1152 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="1780"
  >
    <path
      d="M1099.31 248.166c-12.562-47.3-49.574-84.552-96.568-97.194C917.562 128 576 128 576 128S234.44 128 149.258 150.972c-46.994 12.644-84.006 49.894-96.568 97.194-22.824 85.734-22.824 264.61-22.824 264.61s0 178.876 22.824 264.61c12.562 47.3 49.574 83 96.568 95.642C234.44 896 576 896 576 896s341.56 0 426.742-22.972c46.994-12.642 84.006-48.342 96.568-95.642 22.824-85.734 22.824-264.61 22.824-264.61s0-178.876-22.824-264.61z m-635.02 427.016V350.37l285.478 162.41-285.478 162.402z"
      fill=""
      p-id="1781"
    ></path>
  </svg>
);

const GlobeSVG = () => (
  <svg viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      d="M1.018 7.5h2.49c.037-1.07.189-2.087.437-3.008a9.124 9.124 0 0 1-1.565-.667A6.964 6.964 0 0 0 1.018 7.5zM3.05 3.049c.362.184.763.349 1.198.49.142-.384.304-.744.481-1.078a6.7 6.7 0 0 1 .597-.933A7.01 7.01 0 0 0 3.051 3.05zM8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm-.5 1.077c-.67.204-1.335.82-1.887 1.855-.143.268-.276.56-.395.872.705.157 1.473.257 2.282.287V1.077zm0 4.014c-.91-.03-1.783-.145-2.591-.332a12.344 12.344 0 0 0-.4 2.741H7.5V5.091zm1 2.409V5.091c.91-.03 1.783-.145 2.591-.332.223.827.364 1.754.4 2.741H8.5zm-1 1H4.51c.035.987.176 1.914.399 2.741A13.596 13.596 0 0 1 7.5 10.91V8.5zm1 2.409V8.5h2.99a12.343 12.343 0 0 1-.399 2.741A13.596 13.596 0 0 0 8.5 10.91zm-1 1c-.81.03-1.577.13-2.282.287.12.312.252.604.395.872.552 1.035 1.218 1.65 1.887 1.855V11.91zm-2.173 2.563a6.695 6.695 0 0 1-.597-.933 8.857 8.857 0 0 1-.481-1.078 8.356 8.356 0 0 0-1.198.49 7.01 7.01 0 0 0 2.276 1.52zM2.38 12.175c.47-.258.995-.482 1.565-.667A13.36 13.36 0 0 1 3.508 8.5h-2.49a6.964 6.964 0 0 0 1.362 3.675zm8.293 2.297a7.01 7.01 0 0 0 2.275-1.521 8.353 8.353 0 0 0-1.197-.49 8.859 8.859 0 0 1-.481 1.078 6.688 6.688 0 0 1-.597.933zm.11-2.276A12.63 12.63 0 0 0 8.5 11.91v3.014c.67-.204 1.335-.82 1.887-1.855.143-.268.276-.56.395-.872zm1.272-.688c.57.185 1.095.409 1.565.667A6.964 6.964 0 0 0 14.982 8.5h-2.49a13.355 13.355 0 0 1-.437 3.008zm.437-4.008h2.49a6.963 6.963 0 0 0-1.362-3.675c-.47.258-.995.482-1.565.667.248.92.4 1.938.437 3.008zm-.74-3.96a8.854 8.854 0 0 0-.482-1.079 6.692 6.692 0 0 0-.597-.933c.857.355 1.63.875 2.275 1.521a8.368 8.368 0 0 1-1.197.49zm-.97.264c-.705.157-1.473.257-2.282.287V1.077c.67.204 1.335.82 1.887 1.855.143.268.276.56.395.872z"
    />
  </svg>
);

const LinkSVG = () => (
  <svg viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.354 5.5H4a3 3 0 0 0 0 6h3a3 3 0 0 0 2.83-4H9c-.086 0-.17.01-.25.031A2 2 0 0 1 7 10.5H4a2 2 0 1 1 0-4h1.535c.218-.376.495-.714.82-1z" />
    <path d="M9 5.5a3 3 0 0 0-2.83 4h1.098A2 2 0 0 1 9 6.5h3a2 2 0 1 1 0 4h-1.535a4.02 4.02 0 0 1-.82 1H12a3 3 0 1 0 0-6H9z" />
  </svg>
);

const ChevronSVG = () => (
  <svg
    width="18px"
    height="11px"
    viewBox="0 0 18 11"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="Dashboard-FAQ"
        transform="translate(-1266.000000, -266.000000)"
        fillRule="nonzero"
      >
        <g id="1" transform="translate(343.000000, 234.000000)">
          <path
            d="M0,0 L951.8,0 C958.52,0 961.88,0 964.45,1.308 C966.71,2.458 968.54,4.294 969.69,6.552 C971,9.119 971,12.479 971,19.2 L971,50.8 C971,57.521 971,60.881 969.69,63.448 C968.54,65.706 966.71,67.542 964.45,68.692 C961.88,70 958.52,70 951.8,70 L0,70 L0,0 Z"
            id="Path"
            fill="#F8FAFF"
          ></path>
          <path
            d="M938.81,32.38625 C939.33,31.87125 940.1,31.87125 940.61,32.38625 C940.87,32.64325 941,32.90025 941,33.28625 C941,33.67125 940.87,33.92925 940.61,34.18625 L932.9,41.90025 C932.39,42.41425 931.61,42.41425 931.1,41.90025 L923.39,34.18625 C922.87,33.67125 922.87,32.90025 923.39,32.38625 C923.9,31.87125 924.67,31.87125 925.19,32.38625 L932,39.20025 L938.81,32.38625 Z"
            id="Path"
            fill="#6A35FF"
          ></path>
        </g>
      </g>
    </g>
  </svg>
);

const BellSVG = () => (
  <svg viewBox="0 0 21 23" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g
      id="Page-1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      opacity="0.5"
    >
      <g
        id="Dashboard-money-1"
        transform="translate(-1148.000000, -52.000000)"
        fill="#2D3958"
      >
        <g id="top-bar" transform="translate(1096.000000, 43.000000)">
          <g id="notification" transform="translate(52.641318, 9.000000)">
            <g id="Shape-2" transform="translate(0.000000, 0.000000)">
              <path
                d="M18.5786816,14.4532 C17.8386816,13.7201 17.0686816,12.962 17.0686816,9.3834 C17.0686816,5.7574 14.4086816,2.7419 10.9286816,2.1878 C11.0886816,1.9553 11.1786816,1.6797 11.1786816,1.3975 C11.1786816,0.6257 10.5486816,1.77635684e-15 9.77868164,1.77635684e-15 C9.00868164,1.77635684e-15 8.37868164,0.6257 8.37868164,1.3975 C8.37868164,1.6797 8.46868164,1.9553 8.62868164,2.1878 C5.15868164,2.7419 2.49868164,5.7575 2.49868164,9.3835 C2.49868164,12.9618 1.72868164,13.7199 0.988681643,14.453 C-1.11131836,16.5277 0.418681643,19.5656 2.91868164,19.5656 L6.98868164,19.5656 C6.98868164,21.1092 8.23868164,22.3607 9.77868164,22.3607 C11.3286816,22.3607 12.5786816,21.1092 12.5786816,19.5656 L16.6386816,19.5656 C19.1386816,19.5656 20.6786816,16.5267 18.5786816,14.4532 Z M9.77868164,20.6137 C9.19868164,20.6137 8.72868164,20.1435 8.72868164,19.5656 L10.8286816,19.5656 C10.8286816,20.1435 10.3586816,20.6137 9.77868164,20.6137 Z M2.91868164,17.4693 L16.6386816,17.4693 C17.3686816,17.4693 17.7386816,16.581 17.2286816,16.0634 C15.9886816,14.824 14.9686816,13.6482 14.9686816,9.3835 C14.9686816,6.5212 12.6386816,4.1926 9.77868164,4.1926 C6.91868164,4.1926 4.58868164,6.5212 4.58868164,9.3835 C4.58868164,13.6297 3.58868164,14.815 2.33868164,16.0634 C1.81868164,16.5788 2.18868164,17.4693 2.91868164,17.4693 Z"
                id="Shape"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

const VenmoSVG = () => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 162 162"
  >
    <path
      fill="#2D3958"
      d="M136.8,14.9c4.8,8,7,16.2,7,26.6c0,33.2-28.3,76.2-51.3,106.5H40L19,22.1l46-4.4l11.1,89.6c10.4-16.9,23.2-43.6,23.2-61.7c0-9.9-1.7-16.7-4.4-22.3L136.8,14.9z"
    />
  </svg>
);

const VenmoTextSVG = () => (
  <svg viewBox="0 0 576.9 109.67">
    <title>Venmo</title>
    <path
      fill="#FFF"
      d="M94.82,0c3.9,6.43,5.65,13.06,5.65,21.43,0,26.7-22.79,61.38-41.29,85.73H16.94L0,5.85,37, 2.33l9,72.09c8.37-13.64,18.7-35.07,18.7-49.67,0-8-1.37-13.44-3.51-17.93Z"
    ></path>
    <path
      fill="#FFF"
      d="M142.76,44.61c6.81,0,23.94-3.11,23.94-12.85,0-4.68-3.31-7-7.2-7C152.69,24.75,143.74, 32.92,142.76,44.61ZM142,63.9c0,11.89,6.61,16.56,15.38,16.56,9.55,0,18.69-2.33, 30.57-8.37l-4.48,30.39c-8.37,4.09-21.42,6.82-34.08,6.82-32.12, 0-43.62-19.48-43.62-43.83C105.76,33.9,124.46.38,163,.38c21.23,0,33.1,11.89, 33.1,28.45C196.11,55.53,161.85,63.71,142,63.9Z"
    ></path>
    <path
      fill="#FFF"
      d="M302.86,23.77A97.67,97.67,0,0,1,301.68,37l-11.1, 70.14h-36l10.12-64.3c.19-1.74.78-5.26.78-7.2,0-4.68-2.92-5.84-6.43-5.84-4.67,0-9.34, 2.14-12.46,3.7l-11.48,73.64H198.87l16.55-105h31.35l.4,8.38c7.4-4.87,17.14-10.14, 31-10.14C296.43.39,302.86,9.74,302.86,23.77Z"
    ></path>
    <path
      fill="#FFF"
      d="M409.79,11.88C420.11,4.49,429.85.39,443.28.39c18.49,0,24.93,9.36,24.93,23.39A97.67,97.67, 0,0,1,467,37l-11.09,70.14h-36L430.23,41.5c.19-1.76.59-3.9.59-5.25, 0-5.27-2.92-6.43-6.43-6.43-4.47,0-9,2-12.27,3.7l-11.48, 73.64h-36l10.3-65.66c.19-1.76.58-3.9.58-5.25,0-5.27-2.92-6.43-6.42-6.43-4.68,0-9.34, 2.14-12.46,3.7l-11.49,73.64H308.93l16.55-105h31l1,8.77c7.2-5.25,16.93-10.52, 30-10.52C398.69.39,406.08,5.26,409.79,11.88Z"
    ></path>
    <path
      fill="#FFF"
      d="M539.89,42.47c0-8.57-2.14-14.42-8.56-14.42-14.22,0-17.13,25.13-17.13,38,0,9.75,2.73,15.79 ,9.15,15.79C536.78,81.83,539.89,55.33,539.89,42.47Zm-62.3,22c0-33.12,17.52-64.11, 57.83-64.11C565.79.36,576.9,18.29,576.9,43c0,32.73-17.33,66.63-58.61,66.63-30.58, 0-40.7-20-40.7-45.18Z"
    ></path>
  </svg>
);

export const FacebookIcon = props => (
  <Icon component={FacebookSVG} className="FacebookIcon" {...props} />
);
export const SoundCloudIcon = props => (
  <Icon component={SoundCloudSVG} className="SoundCloudIcon" {...props} />
);
export const TwitterIcon = props => (
  <Icon component={TwitterSVG} className="TwitterIcon" {...props} />
);
export const BandCampIcon = props => (
  <Icon component={BandCampSVG} className="BandCampIcon" {...props} />
);
export const InstagramIcon = props => (
  <Icon component={InstagramSVG} className="InstagramIcon" {...props} />
);
export const SpotifyIcon = props => (
  <Icon component={SpotifySVG} className="SpotifyIcon" {...props} />
);
export const YoutubeIcon = props => (
  <Icon component={YoutubeSVG} className="YoutubeIcon" {...props} />
);
export const GlobeIcon = props => (
  <Icon component={GlobeSVG} className="GlobeIcon" {...props} />
);
export const LinkIcon = props => (
  <Icon component={LinkSVG} className="LinkIcon" {...props} />
);
export const ChevronIcon = props => (
  <Icon component={ChevronSVG} className="ChevronIcon" {...props} />
);
export const BellIcon = props => (
  <Icon component={BellSVG} className="BellIcon" {...props} />
);
export const VenmoIcon = props => (
  <Icon component={VenmoSVG} className="VenmoIcon" {...props} />
);
export const VenmoTextIcon = props => (
  <Icon component={VenmoTextSVG} className="VenmoTextIcon" {...props} />
);

export const EmptyTableMessage = () => (
  <div className="ant-empty ant-empty-normal">
    <div className="ant-empty-image">
      <svg
        className="ant-empty-img-simple"
        width="64"
        height="41"
        viewBox="0 0 64 41"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g transform="translate(0 1)" fill="none" fillRule="evenodd">
          <ellipse
            className="ant-empty-img-simple-ellipse"
            cx="32"
            cy="33"
            rx="32"
            ry="7"
          ></ellipse>
          <g className="ant-empty-img-simple-g" fillRule="nonzero">
            <path d="M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"></path>
            <path
              d="M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z"
              className="ant-empty-img-simple-path"
            ></path>
          </g>
        </g>
      </svg>
    </div>
    <p className="ant-empty-description">
      Share your link to start collecting tips and messages
    </p>
  </div>
);
